/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useCallback } from 'react';

import { CoachButton } from 'bundles/ai-coach-platform/components/building-blocks';
import type { Action } from 'bundles/ai-coach-platform/components/patterns/popover/types';

import _t from 'i18n!nls/ai-coach-platform';

const styles = {
  toolbar: css`
    gap: var(--cds-spacing-100);

    button {
      display: block;
      margin-bottom: var(--cds-spacing-100);
    }
  `,
};

type ClickEvent = React.MouseEvent<HTMLButtonElement>;
type ClickEventHandler = (event: ClickEvent) => void;

type Props = {
  actions: Action[];
  onClose: () => void;
};

/**
 * SuggestedActionsToolbar renders a toolbar containing suggested actions
 */
const SuggestedActionsToolbar = ({ actions, onClose }: Props) => {
  const handleAction = useCallback<(onClick?: ClickEventHandler) => (event: ClickEvent) => void>(
    (onClick) => (event) => {
      onClick?.(event);
      onClose();
    },
    [onClose]
  );

  return (
    <div role="toolbar" aria-label={_t('Suggested actions')} css={styles.toolbar}>
      {actions.map(({ key, ...action }) => (
        <CoachButton key={key} variant="secondary" size="small" {...action} onClick={handleAction(action.onClick)}>
          {action.label}
        </CoachButton>
      ))}
    </div>
  );
};

export default SuggestedActionsToolbar;
